<template>
    <div class="menu_couriers__list_item" :class="classItem" @click.prevent="clickCourier">
        <div class="menu_couriers__list_item_content">
            <div class="menu_couriers__list_item_content_info">
                <img src="/icons/menu-courier.svg" class="menu_couriers__list_item_content_info_logo">
                <div class="menu_couriers__list_item_pos">
                    <span class="menu_couriers__list_item_pos_uniq_id">
                        {{ uniqId }}
                    </span>
                    <div class="menu_couriers__list_item_pos_block">
                        <span class="menu_couriers__list_item_pos_transaction_id">
                            {{ transactionId }}
                        </span>
                        <span class="menu_couriers__list_item_pos_created">
                            {{ created }}
                        </span>
                    </div>
                    <span class="menu_couriers__list_item_pos_comment">
                        {{ comment }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import insertSvg from "../../../mixins/insertSvg";
import formatNumber from "../../../mixins/formatNumber";
import {createHelpers} from "vuex-map-fields";
import {screenSize} from "../../../mixins/screenSize";
import getObjectPathProperty from "../../../mixins/getObjectPathProperty";

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})
const {mapFields: mCouriers} = createHelpers({
    getterType: 'couriers/getCouriersField',
    mutationType: 'couriers/updateCouriersField',
})

export default {
    name: "menu_couriers_item",
    props: {
        courierItem: {
            type: Object,
            required: true,
        },
    },
    components: {},
    mixins: [insertSvg, formatNumber, screenSize],
    mounted() {
    },
    methods: {
        clickCourier() {
            $store.dispatch('couriers/ORDER_SEARCH_STATE', true);
            if (this.isMobileScreen) {
                this.$store.dispatch('couriers/STATE_SELECT_COURIER_ITEM', true);
            }
            //this.$store.dispatch('couriers/CLICK_ITEM_MENU_COURIERS', this.courierItem);
            this.$store.dispatch('couriers/CLICK_ITEM_MENU_COURIERS_POS', this.courierItem);
        }
    },
    computed: {
        ...mUser([
            'user',
        ]),
        ...mCouriers([
            'ordersPos',
            'activeCourierOrder'
        ]),
        classItem() {
            let classCourierItem = {
                'active': false,
                'error': false,
            }
            if (this.activeCourierOrder && this.activeCourierOrder.uniq_id && this.courierItem.uniq_id) {
                classCourierItem.active = this.activeCourierOrder.uniq_id === this.courierItem.uniq_id;
            }
            return classCourierItem;
        },
        courierCode() {
            if (this.courierItem.order_uniq) {
                return this.courierItem.order_uniq;
            }
            return 'No id courier'
        },
        courierDate() {
            if (this.courierItem.order && this.courierItem.order.added) {
                return this.courierItem.order.added;
            }
            return '';
        },
        uniqId() {
            if (this.courierItem.uniq_id) {
                return '#' + this.courierItem.uniq_id;
            }
            return 'No uniq_id';
        },
        transactionId() {
            if (this.courierItem.transaction_id) {
                return this.courierItem.transaction_id;
            }
            return 'No transaction_id';
        },
        created() {
            if (this.courierItem.created) {
                return this.courierItem.created;
            }
            return 'No created';
        },
        comment() {
            if (this.courierItem.comment) {
                return this.courierItem.comment;
            }
            return 'No comment';
        },
    },
}
</script>
